export const findIndexOfQuestionInQstack = (questionId, qstack) => (
  qstack.findIndex((question) => question.id === questionId)
);

export const getQuestionIdByIndex = (questionIndex, qstack) => {
  const { id: questionId } = qstack[questionIndex] ?? {};
  return questionId;
};

export const getQuestionIdByRouteParameter = (questionRouteParameter, qstack) => {
  const { id: questionId } = qstack.find(
    ({ id, path }) => (path === questionRouteParameter) || (!path && id === questionRouteParameter),
  ) ?? {};
  return questionId;
};
